<template>
  <form
    @submit.prevent="submitUser"
    class="Scroll px-6 py-3 w-full h-full border border-gray-400 rounded-md">
    <Message :message="message" />
    <div class="grid grid-cols-12 gap-x-3 gap-y-3 mb-3">
      <div class="col-span-12 sm:col-span-6 flex flex-col">
        <label class="mb-2 text-xs text-white">Nama Pengguna</label>
        <input
          class="form-input px-3 py-3 w-full h-8 rounded-md text-xs"
          type="text"
          v-model="fullname">
      </div>
      <div class="col-span-12 sm:col-span-6 flex flex-col">
        <label class="mb-2 text-xs text-white">Username</label>
        <input
          class="px-3 py-3 w-full h-8 form-input rounded-md text-xs"
          type="text"
          v-model="username">
      </div>
      <div class="col-span-12 sm:col-span-6 flex flex-col">
        <label class="mb-2 text-xs text-white">Password</label>
        <div class="relative">
          <input
            class="form-input px-3 py-3 w-full h-8 rounded-md text-xs"
            :type="typePassword"
            v-model="password">
          <i
            @click="typePassword = typePassword === 'password' ? 'text' : 'password'"
            class="material-icons absolute top-0 right-0 flex w-10 h-8 text-lg justify-center items-center text-gray-500 cursor-pointer">
            {{ typePassword === 'password' ? 'visibility' : 'visibility_off' }}
          </i>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-6 flex flex-col">
        <label class="mb-2 text-xs text-white">Grup Pengguna</label>
        <div class="relative w-full h-8 rounded-md bg-white">
          <input
            v-model="roleName"
            @focusin="toggleSearchRole()"
            @keyup="searchRole($event)"
            class="w-full h-8 rounded-md text-xs"
            type="text">
          <div
            :style="`display: ${roleInSearch ? 'flex' : 'none'}`"
            class="absolute top-9 flex flex-col w-full h-36 overflow-auto bg-white">
            <span
              v-for="role of userRoles.data"
              :key="role.id"
              :class="`w-full px-3 py-3 text-xs cursor-pointer text-xs hover:bg-gray-100 ${roleId === role.id ? 'bg-gray-200' : ''}`"
              :style="`display: ${roleName ? (role.role_name.match(roleNameRegex) ? 'initial' : 'none') : 'inline'}`"
              @click="selectRole(role)">{{ role.role_name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-end">
      <button
        class="bg-green-500 px-2 py-2 rounded-md text-xs text-white"
        type="submit">Simpan</button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Message from './Message.vue'

export default {
  components: { Message },
  name: 'FormUser',
  props: {
    userId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    fullname: null,
    username: null,
    password: null,
    typePassword: 'password',
    roleId: null,
    roleName: null,
    roleInSearch: false
  }),
  computed: {
    ...mapGetters([
      'user',
      'userRoles',
      'message'
    ])
  },
  methods: {
    ...mapActions([
      'loadUser',
      'loadUserRoles',
      'editUser',
      'addUser'
    ]),
    toggleSearchRole: function () {
      this.roleInSearch = this.roleInSearch ? false : true
    },
    searchRole: function (e) {
      if (e) {
        this.roleName = e.target.value

        this.setRoleNameRegex()
      }
    },
    setRoleNameRegex: function () {
      this.roleNameRegex = new RegExp(this.roleName, 'ig')
    },
    selectRole: function (role) {
      this.roleId = role.id
      this.roleName = role.role_name

      this.toggleSearchRole()
    },
    submitUser: async function () {
      const user = {
        fullname: this.fullname,
        username: this.username,
        role_id: this.roleId
      }

      if (typeof this.userId === 'number') {
        user.id = this.userId

        if (this.password) {
          user.password = this.password
        }

        await this.editUser(user)
      } else {
        user.password = this.password

        await this.addUser(user)
      }
    }
  },
  mounted: async function () {
    await this.loadUserRoles({
      offset: 0,
      limit: 999999
    })

    if (typeof this.userId === 'number') {
      await this.loadUser(this.userId)

      this.fullname = this.user.fullname
      this.username = this.user.username
      this.roleId = this.user.role_id
      this.roleName = this.user.role_name

      this.setRoleNameRegex()
    }
  }
}
</script>
